import type * as Types from '../../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import { DsFieldsFragmentDoc } from '../../../graphql/gql-fragments/document-signature.graphql';
import { IdentityFieldsFragmentDoc } from '../../../graphql/gql-fragments/identity.graphql';
import { UserFieldsFragmentDoc, UserFeaturePreferencesFieldsFragmentDoc } from '../../../graphql/gql-fragments/user.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlFoldersQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  fileFilter?: Types.InputMaybe<Types.GqlFileFilterInput>;
}>;


export type GqlFoldersQuery = { file: { id: string, filename: string, filenameSecondaryLang?: string | null, children: { totalCount: number, models: Array<{ id: string, filename: string, filenameSecondaryLang?: string | null }> } } };

export type GqlFileViewQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  fileId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  filter?: Types.InputMaybe<Types.GqlFileFilterInput>;
  lang?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GqlFileViewQuery = { documentTemplates: Array<{ id: string, name: string, latestRevisionId: string }>, company: { id: string, isDemo: boolean, name: string, organizationNumber: string, addressAsStr?: string | null }, companySubscription?: { isActive: boolean } | null, file: { id: string, filename: string, filenameSecondaryLang?: string | null, kind: Types.GqlDocSystemTagKind, agreementId?: string | null, parent?: { id: string, filename: string, filenameSecondaryLang?: string | null } | null, children: { totalCount: number, models: Array<{ id: string, filenameSecondaryLang?: string | null, kind: Types.GqlDocSystemTagKind, filename: string, createdAt: string, zignedAgreementStatus?: Types.GqlZignedAgreementStatus | null, scriveStatus?: Types.GqlScriveDocumentStatus | null, signatureMethod?: Types.GqlDocumentSignatureMethod | null, softDeletable: boolean, children: { totalCount: number }, documentSignatures: Array<{ id: string, signed: boolean, headerPrimaryLang?: string | null, headerSecondaryLang?: string | null, authMethodToView?: Types.GqlScriveAuthMethod | null, authMethodToSign?: Types.GqlScriveAuthMethod | null, deliveryMethod?: string | null, email?: string | null, fileId: string, signatoryId: string, proxyId?: string | null, scriveSignTime?: string | null, scriveSeenTime?: string | null, scriveRejectedTime?: string | null, scriveRejectionReason?: string | null, scriveReadInvitationTime?: string | null, scriveEmailDeliveryStatus?: string | null, zignedParticipantStatus?: Types.GqlZignedParticipantStatus | null, zignedParticipantRole?: Types.GqlZignedParticipantRole | null, zignedParticipantSigningRoomLink?: string | null, createdAt: string, updatedAt: string, signatory: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string }, proxy?: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string } | null }>, meetingDocument?: { id: string, meeting: { id: string, kind: Types.GqlMeetingKind } } | null }> } } };

export type GqlFileSoftDeleteMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  id: Types.Scalars['ID']['input'];
}>;


export type GqlFileSoftDeleteMutation = { fileSoftDelete: { id: string } };

export type GqlCreateFolderMutationVariables = Types.Exact<{
  input: Types.GqlCreateFolderInput;
}>;


export type GqlCreateFolderMutation = { createFolder: { id: string } };

export type GqlMoveFileMutationVariables = Types.Exact<{
  input: Types.GqlMoveFileInput;
}>;


export type GqlMoveFileMutation = { moveFile: { id: string } };

export type GqlUserSetFeaturePreferenceMutationVariables = Types.Exact<{
  feature: Types.Scalars['String']['input'];
  optedIn: Types.Scalars['Boolean']['input'];
}>;


export type GqlUserSetFeaturePreferenceMutation = { userSetFeaturePreference: { id: string, admin: boolean, personalId?: string | null, name?: string | null, jwtEpoch: number, signInCount: number, unconfirmedEmail?: string | null, email?: string | null, emailMd5?: string | null, phone?: string | null, companySuggestionsSyncedDate?: string | null, communicationLanguage: string, currentSignInAt?: string | null, hubspotObjectId?: string | null, createdAt: string, updatedAt: string, referralSource?: Types.GqlReferralSource | null, referralSourceOther?: string | null, featurePreferences: { documents?: boolean | null, documentBannerDismissed?: boolean | null, allowDocumentsBeta?: boolean | null } } };

export type GqlCreateAgreementMutationVariables = Types.Exact<{
  templateRevisionId: Types.Scalars['String']['input'];
  companyId: Types.Scalars['String']['input'];
  name: Types.Scalars['String']['input'];
}>;


export type GqlCreateAgreementMutation = { createAgreement: { id: string, name: string, file: { id: string } } };


export const FoldersDocument = gql`
    query Folders($companyId: ID!, $fileFilter: FileFilterInput) {
  file(companyId: $companyId) {
    id
    filename
    filenameSecondaryLang
    children(offset: 0, limit: 100, filter: $fileFilter, lang: "sv") {
      totalCount
      models {
        id
        filename
        filenameSecondaryLang
      }
    }
  }
}
    `;

/**
 * __useFoldersQuery__
 *
 * To run a query within a React component, call `useFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoldersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      fileFilter: // value for 'fileFilter'
 *   },
 * });
 */
export function useFoldersQuery(baseOptions: Apollo.QueryHookOptions<GqlFoldersQuery, GqlFoldersQueryVariables> & ({ variables: GqlFoldersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlFoldersQuery, GqlFoldersQueryVariables>(FoldersDocument, options);
      }
export function useFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFoldersQuery, GqlFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlFoldersQuery, GqlFoldersQueryVariables>(FoldersDocument, options);
        }
export function useFoldersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlFoldersQuery, GqlFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlFoldersQuery, GqlFoldersQueryVariables>(FoldersDocument, options);
        }
export type FoldersQueryHookResult = ReturnType<typeof useFoldersQuery>;
export type FoldersLazyQueryHookResult = ReturnType<typeof useFoldersLazyQuery>;
export type FoldersSuspenseQueryHookResult = ReturnType<typeof useFoldersSuspenseQuery>;
export type FoldersQueryResult = Apollo.QueryResult<GqlFoldersQuery, GqlFoldersQueryVariables>;
export const FileViewDocument = gql`
    query FileView($companyId: ID!, $fileId: ID, $offset: Int, $limit: Int, $filter: FileFilterInput, $lang: String) {
  documentTemplates(companyId: $companyId) {
    id
    name
    latestRevisionId
  }
  company(id: $companyId) {
    id
    isDemo
    name
    organizationNumber
    addressAsStr
  }
  companySubscription(companyId: $companyId) {
    isActive
  }
  file(id: $fileId, companyId: $companyId) {
    id
    filename
    filenameSecondaryLang
    kind
    agreementId
    parent {
      id
      filename
      filenameSecondaryLang
    }
    children(offset: $offset, limit: $limit, filter: $filter, lang: $lang) {
      totalCount
      models {
        id
        children {
          totalCount
        }
        filenameSecondaryLang
        kind
        filename
        createdAt
        zignedAgreementStatus
        scriveStatus
        signatureMethod
        softDeletable
        documentSignatures {
          ...DsFields
          signatory {
            ...IdentityFields
          }
          proxy {
            ...IdentityFields
          }
        }
        meetingDocument {
          id
          meeting {
            id
            kind
          }
        }
      }
    }
  }
}
    ${DsFieldsFragmentDoc}
${IdentityFieldsFragmentDoc}`;

/**
 * __useFileViewQuery__
 *
 * To run a query within a React component, call `useFileViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileViewQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      fileId: // value for 'fileId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useFileViewQuery(baseOptions: Apollo.QueryHookOptions<GqlFileViewQuery, GqlFileViewQueryVariables> & ({ variables: GqlFileViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlFileViewQuery, GqlFileViewQueryVariables>(FileViewDocument, options);
      }
export function useFileViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlFileViewQuery, GqlFileViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlFileViewQuery, GqlFileViewQueryVariables>(FileViewDocument, options);
        }
export function useFileViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlFileViewQuery, GqlFileViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlFileViewQuery, GqlFileViewQueryVariables>(FileViewDocument, options);
        }
export type FileViewQueryHookResult = ReturnType<typeof useFileViewQuery>;
export type FileViewLazyQueryHookResult = ReturnType<typeof useFileViewLazyQuery>;
export type FileViewSuspenseQueryHookResult = ReturnType<typeof useFileViewSuspenseQuery>;
export type FileViewQueryResult = Apollo.QueryResult<GqlFileViewQuery, GqlFileViewQueryVariables>;
export const FileSoftDeleteDocument = gql`
    mutation FileSoftDelete($companyId: ID!, $id: ID!) {
  fileSoftDelete(companyId: $companyId, id: $id) {
    id
  }
}
    `;
export type GqlFileSoftDeleteMutationFn = Apollo.MutationFunction<GqlFileSoftDeleteMutation, GqlFileSoftDeleteMutationVariables>;

/**
 * __useFileSoftDeleteMutation__
 *
 * To run a mutation, you first call `useFileSoftDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileSoftDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileSoftDeleteMutation, { data, loading, error }] = useFileSoftDeleteMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFileSoftDeleteMutation(baseOptions?: Apollo.MutationHookOptions<GqlFileSoftDeleteMutation, GqlFileSoftDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlFileSoftDeleteMutation, GqlFileSoftDeleteMutationVariables>(FileSoftDeleteDocument, options);
      }
export type FileSoftDeleteMutationHookResult = ReturnType<typeof useFileSoftDeleteMutation>;
export type FileSoftDeleteMutationResult = Apollo.MutationResult<GqlFileSoftDeleteMutation>;
export type FileSoftDeleteMutationOptions = Apollo.BaseMutationOptions<GqlFileSoftDeleteMutation, GqlFileSoftDeleteMutationVariables>;
export const CreateFolderDocument = gql`
    mutation CreateFolder($input: CreateFolderInput!) {
  createFolder(input: $input) {
    id
  }
}
    `;
export type GqlCreateFolderMutationFn = Apollo.MutationFunction<GqlCreateFolderMutation, GqlCreateFolderMutationVariables>;

/**
 * __useCreateFolderMutation__
 *
 * To run a mutation, you first call `useCreateFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFolderMutation, { data, loading, error }] = useCreateFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFolderMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateFolderMutation, GqlCreateFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateFolderMutation, GqlCreateFolderMutationVariables>(CreateFolderDocument, options);
      }
export type CreateFolderMutationHookResult = ReturnType<typeof useCreateFolderMutation>;
export type CreateFolderMutationResult = Apollo.MutationResult<GqlCreateFolderMutation>;
export type CreateFolderMutationOptions = Apollo.BaseMutationOptions<GqlCreateFolderMutation, GqlCreateFolderMutationVariables>;
export const MoveFileDocument = gql`
    mutation MoveFile($input: MoveFileInput!) {
  moveFile(input: $input) {
    id
  }
}
    `;
export type GqlMoveFileMutationFn = Apollo.MutationFunction<GqlMoveFileMutation, GqlMoveFileMutationVariables>;

/**
 * __useMoveFileMutation__
 *
 * To run a mutation, you first call `useMoveFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveFileMutation, { data, loading, error }] = useMoveFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveFileMutation(baseOptions?: Apollo.MutationHookOptions<GqlMoveFileMutation, GqlMoveFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlMoveFileMutation, GqlMoveFileMutationVariables>(MoveFileDocument, options);
      }
export type MoveFileMutationHookResult = ReturnType<typeof useMoveFileMutation>;
export type MoveFileMutationResult = Apollo.MutationResult<GqlMoveFileMutation>;
export type MoveFileMutationOptions = Apollo.BaseMutationOptions<GqlMoveFileMutation, GqlMoveFileMutationVariables>;
export const UserSetFeaturePreferenceDocument = gql`
    mutation UserSetFeaturePreference($feature: String!, $optedIn: Boolean!) {
  userSetFeaturePreference(feature: $feature, optedIn: $optedIn) {
    ...UserFields
    featurePreferences {
      ...UserFeaturePreferencesFields
    }
  }
}
    ${UserFieldsFragmentDoc}
${UserFeaturePreferencesFieldsFragmentDoc}`;
export type GqlUserSetFeaturePreferenceMutationFn = Apollo.MutationFunction<GqlUserSetFeaturePreferenceMutation, GqlUserSetFeaturePreferenceMutationVariables>;

/**
 * __useUserSetFeaturePreferenceMutation__
 *
 * To run a mutation, you first call `useUserSetFeaturePreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSetFeaturePreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSetFeaturePreferenceMutation, { data, loading, error }] = useUserSetFeaturePreferenceMutation({
 *   variables: {
 *      feature: // value for 'feature'
 *      optedIn: // value for 'optedIn'
 *   },
 * });
 */
export function useUserSetFeaturePreferenceMutation(baseOptions?: Apollo.MutationHookOptions<GqlUserSetFeaturePreferenceMutation, GqlUserSetFeaturePreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUserSetFeaturePreferenceMutation, GqlUserSetFeaturePreferenceMutationVariables>(UserSetFeaturePreferenceDocument, options);
      }
export type UserSetFeaturePreferenceMutationHookResult = ReturnType<typeof useUserSetFeaturePreferenceMutation>;
export type UserSetFeaturePreferenceMutationResult = Apollo.MutationResult<GqlUserSetFeaturePreferenceMutation>;
export type UserSetFeaturePreferenceMutationOptions = Apollo.BaseMutationOptions<GqlUserSetFeaturePreferenceMutation, GqlUserSetFeaturePreferenceMutationVariables>;
export const CreateAgreementDocument = gql`
    mutation CreateAgreement($templateRevisionId: String!, $companyId: String!, $name: String!) {
  createAgreement(
    templateRevisionId: $templateRevisionId
    companyId: $companyId
    name: $name
  ) {
    id
    name
    file {
      id
    }
  }
}
    `;
export type GqlCreateAgreementMutationFn = Apollo.MutationFunction<GqlCreateAgreementMutation, GqlCreateAgreementMutationVariables>;

/**
 * __useCreateAgreementMutation__
 *
 * To run a mutation, you first call `useCreateAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgreementMutation, { data, loading, error }] = useCreateAgreementMutation({
 *   variables: {
 *      templateRevisionId: // value for 'templateRevisionId'
 *      companyId: // value for 'companyId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateAgreementMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateAgreementMutation, GqlCreateAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateAgreementMutation, GqlCreateAgreementMutationVariables>(CreateAgreementDocument, options);
      }
export type CreateAgreementMutationHookResult = ReturnType<typeof useCreateAgreementMutation>;
export type CreateAgreementMutationResult = Apollo.MutationResult<GqlCreateAgreementMutation>;
export type CreateAgreementMutationOptions = Apollo.BaseMutationOptions<GqlCreateAgreementMutation, GqlCreateAgreementMutationVariables>;